import mapValues from 'lodash/mapValues'
import toPairs from 'lodash/toPairs'
import { cloneDeep } from 'lodash'

const hydrate = (value, resolve) => {
    if (isIdentifier(value)) {
        return resolve(value.type, value.id)
    } else if (Array.isArray(value)) {
        return value.map(v => hydrate(v, resolve))
    } else if (value && typeof value === 'object') {
        return Object.assign(value, mapValues(value, v => hydrate(v, resolve)))
    } else {
        return value
    }
}

const isIdentifier = value => (
    value &&
    typeof value === 'object' &&
    Object.getOwnPropertyNames(value).length === 2 &&
    value.type &&
    value.id
)

export default function(response) {
    let { root, resources } = cloneDeep(response)

    const resolve = (type, id) => resources[type][id]

    resources = hydrate(resources, resolve)

    toPairs(resources).forEach(([ type, resourcesById ]) => {
        toPairs(resourcesById).forEach(([ id, model ]) => {
            model.type = type
            model.id = id
        })
    })

    return {
        root: hydrate(root, resolve),
        resources,
    }
}